const italyDevUrl =
  "https://data-tracking-api-italy-dev-v2-dot-mobs-2019-ncov-web.appspot.com/";

export { italyDevUrl };
